import { I18nData } from "@/types/i18n";
import "./footer.scss";
import { Branding } from "@/types/branding";

interface FooterProps {
  i18nData?: I18nData;
  locale?: string;
  branding?: Branding;
}

export default function Footer({
  i18nData,
  branding,
  locale = "en",
}: FooterProps) {
  // Use provided locale or fallback to first available
  const lang =
    i18nData?.[locale] || (i18nData && Object.values(i18nData)[0]) || {};
  return (
    <footer role="contentinfo" aria-label={lang?.footer_aria_label || "Footer"}>
      <a
        href="https://scifree.se"
        target="_blank"
        rel="noopener noreferrer"
        aria-label={lang?.scifree_link_aria_label || "SciFree"}
        title="Link to SciFree website"
        id="logoToSciFree"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: 0,
          }}
        >
          <p
            style={{
              margin: 0,
              marginBottom: 4,
              fontSize: 18,
              color: "white",
              letterSpacing: 2,
              fontFamily: "Helvetica Neue",
            }}
          >
            POWERED BY
          </p>
          <p
            style={{
              margin: 0,
              fontFamily: "Helvetica Neue",
              fontWeight: 700,
              fontSize: 36,
              letterSpacing: 1,
              color: "white",
            }}
          >
            SciFree
          </p>
        </div>
      </a>
      <div id="link-wrapper">
        <a
          href="https://scifree.se/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          id="policy"
          aria-label={lang?.privacy_policy_text || "Privacy policy"}
          title="Link to SciFree Privacy Policy"
        >
          {lang?.privacy_policy_text ?? "Privacy policy"}
        </a>
        <a
          href={
            branding?.accessibility_url ?? "https://scifree.se/accessibility"
          }
          target="_blank"
          rel="noopener noreferrer"
          id="accessibility"
          aria-label={lang?.accessibility_text || "Accessibility"}
          title="Link to SciFree Accessibility page"
        >
          {lang?.accessibility_text ?? "Accessibility"}
        </a>
      </div>
    </footer>
  );
}
